module.exports = __webpack_public_path__ + "img/kypho 480x480.3b30842f.jpg";